import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

// Components
import MuiHeader from "../../components/MuiHeader";
import MuiLoader from "../../components/MuiLoader";
import ContentEditor from "../../components/ContentEditor";
import ContentPreview from "../../components/ContentPreview";

// Thunks
import { getpgeactivityskillThunk, getmasteractivitiydetailsThunk, createmasteractivitiesThunk, updatemasteractivitiesThunk } from "../pge_activity/PgeActivity.Thunk";
//import { preferedlanguage_change, class_change, subject_change, skill_change } from "../pge_activity/PgeActivity.Slice";
import { preferedlanguage_change, class_change, usertype_change, skill_change } from "./EceActivity.Slice";
import { geteceactivityskillThunk, getmastereceactivitiydetailsThunk, updatemastereceactivitiesThunk, deleteEceContent } from "./EceActivity.Thunk";
// MUI
import { Avatar, Button, InputLabel, FormControl, Select, Box, Grid, Card, CardHeader, IconButton, Menu, MenuItem, useMediaQuery, useTheme } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import AnalyticsIcon from "@mui/icons-material/Analytics";
import { pink } from "@mui/material/colors";

// toastify
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// swal
import Swal from "sweetalert2";

function PgeActivityPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // ------------ Grid gallery view -----------
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  // ---------------------------------------------

  // --------- options for dropdowns ---------
  const language_select_option_list = [
    { value: "od", text: "ଓଡିଆ" },
    { value: "en", text: "English" },
  ];
  const usertype_select_option_list = [
    { value: "fellow", text: "Educator" },
    { value: "anganwadi", text: "Anganwadi" },
    { value: "school", text: "School" },
  ];
  const class_select_option_list = [
    { value: "1", text: "1" },
    { value: "2", text: "2" },
    { value: "3", text: "3" },
    { value: "4", text: "4" },
    { value: "5", text: "5" },
  ];
  // ------------------------------------------

  // ------------ dropdowns on change ----------------
  const preflanguage_select_onchange = (event) => {
    dispatch(preferedlanguage_change(event.target.value));
  };
  const usertype_select_onchange = (event) => {
    dispatch(usertype_change(event.target.value));
  };
  const class_select_onchange = (event) => {
    dispatch(class_change(event.target.value));
    // const params = { clas };
    dispatch(geteceactivityskillThunk(event.target.value));
  };
  const skill_select_onchange = (event) => {
    dispatch(skill_change(event.target.value));
  };
  // -------------------------------------------------

  // -------------- Loader -----------------------
  const loading = useSelector((state) => state.PgeActivitySlice.loading);
  // ---------------------------------------------

  // -------------- Card-item vertical menu ---------------
  const ITEM_HEIGHT = 48;
  const [selectedIndex, setSelectedIndex] = useState(-1);
  const [selectedSegment, setSelectedSegment] = useState({});
  const [anchorEl, setAnchorEl] = useState(null);
  const openVertMenu = Boolean(anchorEl);
  const handleVertMenuClick = (event, eachsegment, index) => {
    setAnchorEl(event.currentTarget);
    setSelectedIndex(index);
    setSelectedSegment(eachsegment);
  };
  const handleVertMenuClose = () => {
    setAnchorEl(null);
    setSelectedIndex(-1);
    setSelectedSegment({});
  };
  // ---------------------------------------------

  // --------------------- data --------------------------
  const data = useSelector((state) => state.EceActivitySlice.data);
  //console.log("Ece data--------------------------->", data);
  const skill_select_option_list = useSelector((state) => state.EceActivitySlice.skills);
  // -----------------------------------------------------

  // ---------------- navigate to skillset manager -------------
  const navigate_to = () => {
    navigate("/eceskillsetmanager");
  };
  // ------------------------------------------------------------

  // ------------ Load data & skill ----------------
  const _id = data.length > 0 ? data[0]["_id"] : "";
  const existing_segments = data.length > 0 ? data : [];
  //console.log("-->data: ", data);
  const program = "ece";
  const preferedlanguage = useSelector((state) => state.EceActivitySlice.preferedlanguage);
  const clas = useSelector((state) => state.EceActivitySlice.clas);
  const usertype = useSelector((state) => state.EceActivitySlice.usertype);
  const skill = useSelector((state) => state.EceActivitySlice.skill);
  const disable_content_button = useSelector((state) => state.EceActivitySlice.disable_content_button);
  ////console.log("disable_content_button------------>",disable_content_button)

  useEffect(() => {
    // const load_skills_list = () => {
    //   if (
    //     preferedlanguage.length > 0 &&
    //     clas.length > 0 &&
    //     usertype.length > 0
    //   ) {
    //     const params = { clas };
    //     dispatch(geteceactivityskillThunk(clas));
    //   }
    // };
    const load_data = () => {
      if (preferedlanguage.length > 0 && clas.length > 0 && usertype.length > 0 && skill.length > 0) {
        const params = { usertype, clas, skill };
        dispatch(getmastereceactivitiydetailsThunk(params));
      }
    };
    // load_skills_list();
    load_data();
  }, [dispatch, preferedlanguage, clas, usertype, skill]);
  // -----------------------------------------------

  // -------------- Editor -----------------------
  const [openEditor, setOpenEditor] = useState(false);
  const [operation, setOperation] = useState("");
  const [contenttitle, setContenttitle] = useState("");
  const [contentduration, setContentduration] = useState(0);
  const [content, setContent] = useState("");
  const [index, setIndex] = useState(-1);

  const handleCloseEditor = () => {
    setOpenEditor(false);
  };

  const saveEditorContentData = (data) => {
    // //console.log("-->    data: ", data);
    if (data.contenttitle.length <= 0) {
      toast.error("Enter a title for this content");
    } else if (parseInt(data.contentduration) <= 0) {
      toast.error("Enter a valid expected duration for this content");
    } else if (isNaN(parseInt(data.contentduration))) {
      toast.error("Entered duration is not a number");
    } else if (data.content === "<div><br></div>") {
      toast.error("Enter some contents to save");
    } else if (data.content.length <= 0) {
      toast.error("Enter some contents to save");
    } else {
      if (data.operation === "save") createNewContent(data);
      else if (data.operation === "update") updateContent(data); // change this function
    }
  };
  // ---------------------------------------------

  // -------------- Preview -----------------------
  const [openPreview, setOpenPreview] = useState(false);
  const [previewContenttitle, setPreviewContenttitle] = useState("");
  const [previewContent, setPreviewContent] = useState("");

  const contentOnClick = (segment) => {
    setPreviewContenttitle(segment.skillname);
    setPreviewContent(segment.textContent);
    setOpenPreview(true);
  };

  const handleClosePreview = () => {
    setOpenPreview(false);
  };
  // ----------------------------------------------

  // ----------- create, update delete button click ----------
  const create_content_button_click = () => {
    setOperation("save");
    setContenttitle("");
    setContentduration(0);
    setContent("");
    setIndex(-1);
    setOpenEditor(true);
  };

  const update_content_button_click = (eachsegment, index) => {
    handleVertMenuClose();
    // //console.log("update : ", "    index: ", index, "    segment", eachsegment);
    setOperation("update");
    setContenttitle(eachsegment.skillname);
    setContentduration(eachsegment.duration);
    setContent(eachsegment.textContent);
    setIndex(index);
    setOpenEditor(true);
  };

  const delete_content_button_click = (eachsegment, index) => {
    handleVertMenuClose();
    Swal.fire({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this record!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      //cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        //console.log("result.isConfirmed---->", result.isConfirmed);
        deleteEceContent(eachsegment.skillid).then((response) => {
          //console.log("check--->", response.data);
          if (response.data.status === "success") {
            const params = { usertype, clas, skill };
            dispatch(getmastereceactivitiydetailsThunk(params));
            toast.success("Changes made successfully");
          }
        });
        //console.log("delete id---->", eachsegment);
      }
    });
  };

  const createNewContent = (data) => {
    let newobj = {
      skillid: skill,
      duration: data.contentduration,
      textContent: data.content,
    };

    saveSegmentsIntoDatabase(newobj);
  };

  const updateContent = (data) => {
    // const index = data.index;
    // let selected_segment = existing_segments[index];
    // let updatedObj = {
    //   skillid: selected_segment.id,
    //   textContent: data.content,
    // };

    // let updated_segments = existing_segments.map((obj, i) => {
    //   if (i === index) return updatedObj;
    //   return obj;
    // });
    let newobj = {
      skillid: skill,
      duration: data.contentduration,
      textContent: data.content,
    };
    saveSegmentsIntoDatabase(newobj);
  };

  const saveSegmentsIntoDatabase = (updated_segments) => {
    //console.log("====================================");
    //console.log(updated_segments, "updated_segments-------->");
    //console.log("====================================");
    // const body = {
    //   segment: updated_segments,
    // };
    dispatch(updatemastereceactivitiesThunk({ updated_segments }))
      .then(handleCloseEditor())
      .then(() => {
        const params = { usertype, clas, skill };

        dispatch(getmastereceactivitiydetailsThunk(params));
        toast.success("Changes made successfully");
      });
  };
  // -------------------------------------------------

  return (
    <>
      <div>
        <MuiHeader header="ECE Activity" />
        <FormControl sx={{ m: 1, minWidth: 120 }} style={{ marginTop: 73 }} size="small">
          <InputLabel id="demo-select-small">Language</InputLabel>
          <Select labelId="demo-select-small" id="demo-select-small" value={preferedlanguage} label="Language" onChange={preflanguage_select_onchange}>
            <MenuItem value="">None</MenuItem>
            {language_select_option_list.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.text}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl sx={{ m: 1, minWidth: 120 }} style={{ marginTop: 73 }} size="small">
          <InputLabel id="demo-select-small">Usertype</InputLabel>
          <Select labelId="demo-select-small" id="demo-select-small" value={usertype} label="Subject" onChange={usertype_select_onchange}>
            <MenuItem value="">None</MenuItem>
            {usertype_select_option_list.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.text}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl sx={{ m: 1, minWidth: 120 }} style={{ marginTop: 73 }} size="small">
          <InputLabel id="demo-select-small">Class</InputLabel>
          <Select labelId="demo-select-small" id="demo-select-small" value={clas} label="Class" onChange={class_select_onchange}>
            <MenuItem value="">None</MenuItem>
            {class_select_option_list.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.text}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl sx={{ m: 1, minWidth: 120 }} style={{ marginTop: 73 }} size="small">
          <InputLabel id="demo-select-small">Skill</InputLabel>
          <Select labelId="demo-select-small" id="demo-select-small" value={skill} label="Skill" onChange={skill_select_onchange}>
            <MenuItem value="">None</MenuItem>
            {skill_select_option_list.map((option) => (
              <MenuItem key={option.skillid} value={option.skillid}>
                {option.skillname}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <Button onClick={navigate_to} variant="outlined" sx={{ m: 1, minWidth: 120 , marginTop: 0}} size="small">
          ECE Skillset Manager
        </Button>
      </div>

      {/* Show List */}
      <div>
        <Button style={{ marginTop: -30}} onClick={create_content_button_click} variant="contained" disabled={disable_content_button}>
          Create New Content
        </Button>
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={3}>
            {existing_segments.map((eachsegment, index) => (
              <Grid item xs={12} sm={isSmallScreen ? 12 : 6} md={4} key={index}>
                <Card sx={{ maxWidth: 345 }}>
                  <CardHeader
                    avatar={
                      <Avatar sx={{ bgcolor: pink[500] }}>
                        <AnalyticsIcon />
                      </Avatar>
                    }
                    action={
                      <>
                        <IconButton id={index + 1.1} onClick={(e) => handleVertMenuClick(e, eachsegment, index)} aria-controls={openVertMenu ? { index } : undefined} aria-expanded={openVertMenu ? "true" : undefined} aria-haspopup="true">
                          <MoreVertIcon />
                        </IconButton>
                      </>
                    }
                    title={
                      <div onClick={() => contentOnClick(eachsegment)}>
                        <div style={{ cursor: "pointer" }}>{eachsegment.skillname}</div>
                        <div style={{ color: "grey" }}>
                          {eachsegment.skillid ? eachsegment.skillid : ""}
                          <br />
                          {eachsegment.duration ? eachsegment.duration : 0} Minute(s)
                        </div>
                      </div>
                    }
                  />
                  {/* <CardMedia component="img" height="194" image={require("../../media/images/content.webp")} alt="content" />
                  <CardContent></CardContent> */}
                </Card>
              </Grid>
            ))}
            <Menu
              id={selectedIndex}
              anchorEl={anchorEl}
              open={openVertMenu}
              onClose={handleVertMenuClose}
              MenuListProps={{
                "aria-labelledby": "vert-button",
              }}
              PaperProps={{
                style: {
                  maxHeight: ITEM_HEIGHT * 4.5,
                  width: "20ch",
                },
              }}
            >
              <MenuItem onClick={() => update_content_button_click(selectedSegment, selectedIndex)}>Edit</MenuItem>
              <MenuItem onClick={() => delete_content_button_click(selectedSegment, selectedIndex)}>Delete</MenuItem>
            </Menu>
          </Grid>
        </Box>
      </div>

      {/* Editor */}
      <ContentEditor open={openEditor} operation={operation} contenttitle={contenttitle} setContenttitle={setContenttitle} contentduration={contentduration} setContentduration={setContentduration} content={content} setContent={setContent} index={index} onSave={saveEditorContentData} onClose={handleCloseEditor} />

      {/* Preview */}
      <ContentPreview open={openPreview} contenttitle={previewContenttitle} content={previewContent} onClose={handleClosePreview} />

      {/* Loader */}
      <MuiLoader open={loading} />

      {/* Toaster */}
      <ToastContainer />
    </>
  );
}

export default PgeActivityPage;
